import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frame: { type: String, default: "modal" } }

  connect() {
    this._handleEsc = this._handleEsc.bind(this)
    document.addEventListener("keydown", this._handleEsc)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleEsc)
  }

  close() {
    const frame = document.getElementById(this.frameValue)
    if (frame) frame.innerHTML = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  _handleEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
